import { Center, Spinner, Text } from "@chakra-ui/react";
import { skipToken } from "@reduxjs/toolkit/query";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useGetNeedQuery } from "../../../autogen/bff-api";
import { NeedViewRoot } from "./NeedViewRoot";

export const NeedView = () => {
  const { t } = useTranslation();
  const { needId } = useParams<{ needId: string }>();
  const { data, isLoading, isError, refetch } = useGetNeedQuery(needId ? { needId } : skipToken);

  if (!needId) return null;
  if (isLoading) {
    return (
      <Center py="20">
        <Spinner color="smPrimary" />
      </Center>
    );
  }
  if (isError || !data) {
    return (
      <Center py="20">
        <Text color="smMuted">{t("Could not load the need.")}</Text>
      </Center>
    );
  }
  return <NeedViewRoot needId={needId} need={data} refetch={refetch} />;
};
